import React, { useState, useRef, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PaymentsIcon from '@mui/icons-material/Payments';
import SecurityIcon from '@mui/icons-material/Security';
import ShareIcon from '@mui/icons-material/Share';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useNavigate, useLocation } from 'react-router-dom';
import { isInApp } from '../utils/environment';
import { GlobalStyles } from '@mui/material';
import TopBar from '../components/TopBar';
import { removeToken } from '../utils/auth';
import { showMessage } from '../utils';


const ReferralProgram = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // 获取URL中的inviteCode
  const searchParams = new URLSearchParams(window.location.search);
  const inviteCode = searchParams.get('inviteCode');

  // 获取提现记录
  console.log('location',location);
  const referralData = [
    { range: '1-10', commission: '$500' },
    { range: '11-100', commission: '$5,000' },
    { range: '101-500', commission: '$25,000' },
    { range: '501-1000', commission: '$50,000' },
    { range: '1000+', commission: '$50,000+' },
  ];

  const referralDataBusiness = [
    { range: '1-10', commission: '$1,000' },
    { range: '11-100', commission: '$10,000' },
    { range: '101-500', commission: '$50,000' },
    { range: '501-1000', commission: '$100,000' },
    { range: '1000+', commission: '$100,000+' },
  ];

  const steps = [
    {
      title: 'Join the Program',
      description: 'Sign up and get approved to become an ambassador'
    },
    {
      title: 'Share Your Link',
      description: 'Share your unique referral link with friends, followers, and on social media'
    },
    {
      title: 'Earn Big - No Limits',
      description: 'Get $50 for each new user who spends $50 or more'
    }
  ];

  const rules = [
    {
      icon: <ShareIcon />,
      title: 'Invite Your Friends',
      description: 'Share it with your network and help them save their first time!'
    },
    {
      icon: <CardGiftcardIcon />,
      title: 'Your Friends Save $$$',
      description: 'Each friend you invite gets a special welcome bonus'
    },
    {
      icon: <MonetizationOnIcon />,
      title: 'You Earn Unlimited Rewards',
      description: 'Get $50 for each new user who spends $50 or more'
    }
  ];

  const services = [
    {
      icon: <SupportAgentIcon />,
      title: 'Dedicated Ambassador Support',
      description: "You'll get 24/7 support – We Got Your Back!"
    },
    {
      icon: <PaymentsIcon />,
      title: 'Fast Payment System',
      description: 'Get Paid Weekly – No Minimum Payout'
    },
    {
      icon: <SecurityIcon />,
      title: 'No Fees, No Strings',
      description: 'Keep 100% of what you earn'
    }
  ];

  const questions = [
    {
      title: 'Who can join the program?',
      content: 'Anyone can join the program. All you need is a valid email address and a valid phone number.' 
    },
    {
      title: 'Referral Payout',
      content: 'A referral is a new customer who signs up for uTaxes using your unique referral link. The referred customer must meet eligibility criteria, such as being a new user and subscribing to a paid uTaxes service.'
    },
    {
      title: 'What is a referral?',
      content: 'Yes! When your referral signs up using your link, they receive an exclusive discount on their first-year subscription to uTaxes. The specific discount percentage or dollar amount may vary based on ongoing promotions.'
    },
    {
      title: 'Does my referral receive any benefits?',
      content: 'A "closed deal" occurs when a referred customer successfully signs up for a paid uTaxes subscription and completes their first payment. Only closed deals qualify for referral payouts.'
    },
    {
      title: 'What is a "closed deal"?',
      content: (
        <span>
          A "Closed Deal" occurs when your referred client meets the following criteria:<br />
          1. Successful Registration and Payment: The referred client registers for a paid uTaxes subscription through your unique referral link and completes the initial payment.<br />
          2. Submission of a Valid Tax Return: The referred client uses uTaxes to submit a legitimate tax return to the IRS, such as Form 1040 for individuals or Form 1120 for corporations.<br />
          To ensure the integrity and uniqueness of each referral, the following conditions must be met:<br />
          ● Valid Taxpayer Identification: The referred client must provide a valid Social Security Number (SSN) or Employer Identification Number (EIN), which must not duplicate any existing records in the uTaxes system.<br />
          ● Unique Filing Entity: Each taxpayer (individual or business entity) is permitted only one uTaxes account. Duplicate accounts, test accounts, or accounts that do not submit an official tax return are ineligible for referral rewards.<br />
          Please note that only referrals meeting all the above criteria are eligible for referral rewards.
        </span>
      )
    }
  ];

  // 添加检测设备类型的函数
  const handleDownload = () => {
    // 定义正则表达式常量，避免重复创建
    const ANDROID_REGEX = /Android/i;
    const IPAD_REGEX = /iPad/i;
    const IPOD_IPHONE_REGEX = /iPod|iPhone/i;
    const MAC_OS_REGEX = /Mac OS X/;

    const userAgent = window.navigator.userAgent;
    // 检查是否为 Android 设备
    const isAndroid = ANDROID_REGEX.test(userAgent);
    // 检查是否为 iPad 设备
    const isIPad = !isAndroid && IPAD_REGEX.test(userAgent);
    // 检查是否为 iPhone 或 iPod 设备
    const isIPhone = !isAndroid && IPOD_IPHONE_REGEX.test(userAgent);
    // 检查是否为 Mac 设备
    const isMac = MAC_OS_REGEX.test(userAgent);
    // 检查是否为 iOS 设备
    const isIOS = isIPhone || isIPad;
    // 检查是否为 iOS 或 Mac 设备
    const isIOSMac = isIOS || isMac;

    const downloadUrl = isIOSMac 
      ? 'https://apps.apple.com/us/app/utaxes/id6740635190?pid=Ambassador'
      : 'https://play.google.com/store/apps/details?id=com.utaxes.api&hl=en&referrer=utm_source%3DAmbassador';
    
    window.open(downloadUrl, '_blank');
  };

  // 修改跳转逻辑
  const handleGetStarted = () => {
    // 如果有inviteCode，则带着参数跳转到注册页
    if (inviteCode) {
      navigate(`/campaigns/invitations/login?inviteCode=${inviteCode}`,{state:{from:{pathname:location}}})
    } else {
      navigate('/campaigns/invitations/login',{state:{from:{pathname:location}}});
    }
  };

  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const handleUserMenuOpen = (event) => setUserMenuAnchor(event.currentTarget);
  const handleUserMenuClose = () => setUserMenuAnchor(null);

  function isLogin() {
    // 你可以根据实际项目判断方式调整
    return !!localStorage.getItem('token');
  }

  return (
    <Box>
      <TopBar
        isLogin={false}
        onLogin={() => navigate('/campaigns/invitations/login')}
        onShareClick={() => navigate('/campaigns/invitations/referral')}
        onCouponClick={() => navigate('/campaigns/invitations/tax-declaration')}
        onAvatarClick={handleUserMenuOpen}
        userMenuAnchor={userMenuAnchor}
        onUserMenuClose={handleUserMenuClose}
        navigate={navigate}
        onLogout={() => {
          removeToken();
          showMessage("Logout successfully", "success");
          setTimeout(() => {
            navigate("/login");
          }, 1500);
          handleUserMenuClose();
        }}
      />
      <Box sx={{ 
        width: '100%',
        maxWidth: { xs: '1200px', md: '100%' },
        margin: '0 auto',
        bgcolor: '#F8FAFC'
      }}>
        {/* Header */}
        <Box
          component="a"
          onClick={(e) => {
            e.preventDefault(); // 阻止默认的链接跳转
            navigate("/login", {state: {from: {pathname: location}}});
          }}
          sx={{
            mt: { xs: '56px', md: '64px' },
            width: '100%',
            // background: 'linear-gradient(90deg, rgb(76 12 34) 0%, rgb(1 95 247) 100%)',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer', // 鼠标悬停变小手
            textDecoration: 'none', // 去除下划线
          }}
        >
          {/* 比例容器，保持 1200x628 的比例 */}
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              maxWidth: '1200px',
              mx: 'auto',
              '&:before': {
                content: '""',
                display: 'block',
                paddingTop: '66.6666%',
              },
            }}
          >
            <Box
              component="img"
              src={`${process.env.PUBLIC_URL}/images/banner-1.jpg`}
              alt="Header background"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>
        </Box>

        {/* 只保留按钮，居中显示 */}
        <Container
          sx={{
            position: 'relative',
            zIndex: 1,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            my: '20px',
          }}
        >
          <Box
            onClick={handleGetStarted}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(90deg, #10B981 0%, #059669 100%)',
              color: 'white',
              fontSize: { xs: '18px', md: '22px' },
              fontWeight: 700,
              borderRadius: '32px',
              px: { xs: 5, md: 8 },
              py: { xs: 2, md: 2.5 },
              boxShadow: '0 8px 32px 0 rgba(16,185,129,0.25)',
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(.4,2,.6,1)',
              letterSpacing: 2,
              textTransform: 'uppercase',
              '&:hover': {
                background: 'linear-gradient(90deg, #059669 0%, #10B981 100%)',
                boxShadow: '0 12px 32px 0 rgba(16,185,129,0.35)',
                transform: 'scale(1.05)',
              },
            }}
          >
            Get started
          </Box>
        </Container>

        {/* 主要内容区域 */}
        <Container sx={{ 
          maxWidth: '1200px !important',
          px: { xs: 0, md: 3 },
          mx: 'auto',
          position: 'relative',
          zIndex: 1,
          bgcolor: '#FFF',
          borderRadius: '12px',
          pt: 3
        }}>
          {/* Rewards Section - 统一展示 */}
          <Box sx={{ 
            px: { xs: 2, md: 0 }
          }}>
            {/* Commission Display */}
            <Box sx={{ mb: 3 }}>
              {/* Commission Amount Box */}
              <Box
                sx={{
                  border: "1px solid #E5E7EB",
                  borderRadius: 2,
                  p: 2,
                  mb: 2,
                  bgcolor: "white",
                }}
              >
                {/* Gradient Motivation Text */}
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 500,
                    background: "linear-gradient(101deg, #7123DF 0%, rgba(254, 46, 185, 0.7) 42.57%, #FF8486 70.27%, #FF9F38 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    textAlign: "center",
                    mb: 2,
                  }}
                >
                  The more <b>you refer</b>, the more <b>you earn!</b>
                </Typography>

                {/* Steps */}
                {[ 
                  {
                    title: "Invite friends, family — anyone!",
                    description: "Share your unique referral link with your network",
                  },
                  {
                    title: "Share your link on social media",
                    description: "LinkedIn, Facebook, WhatsApp, TikTok, and more",
                  },
                  {
                    title: "Every referral = real cash",
                    description: "We'll send you a check by mail for each successful referral",
                  },
                  {
                    title: "Earn up to $100,000+",
                    description: "Just by inviting friends to join our platform",
                  },
                ].map((item, index) => (
                  <Box key={index} sx={{ display: "flex", mb: 2 }}>
                    <Box
                      sx={{
                        minWidth: 28,
                        height: 28,
                        borderRadius: "50%",
                        backgroundColor: "#F3F4F6",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: 600,
                        mr: 2,
                      }}
                    >
                      {index + 1}
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 600, fontSize: "15px", mb: 0.5 }}>
                        {item.title}
                      </Typography>
                      <Typography sx={{ fontSize: "14px", color: "#6B7280" }}>
                        {item.description}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>

            </Box>
            {/* 新增的税务卡片部分 */}
            <Box sx={{ px: { xs: 0, md: 0 }, mb: 3 }}>
              <Typography sx={{ 
                fontSize: '20px',
                fontWeight: 600,
                color: '#333',
                mb: 3
              }}>
                Invite & Earn
              </Typography>

              {/* 税务卡片容器 */}
              <Box sx={{ 
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: 3,
                mb: 3
              }}>
                {/* Individual Tax Filing Card */}
                <Box sx={{ 
                  flex: 1,
                  bgcolor: 'white',
                  borderRadius: 1,
                  overflow: 'hidden',
                  boxShadow: '0px 4px 24px 0px #0000000D'
                }}>
                  {/* 卡片头部 */}
                  <Box
                    sx={{
                      background: 'linear-gradient(90deg, rgb(143, 34, 46) 0%, rgb(22, 119, 255) 100%)',
                      p: 3,
                      color: 'white',
                      borderTopLeftRadius: 8,
                      borderTopRightRadius: 8,
                    }}
                  >
                    <Typography sx={{ 
                      fontSize: '12px',
                      fontWeight: 900,
                      mb: 2,
                      textAlign: 'center',
                      fontFamily: 'Roboto'
                    }}>
                      Tax Filing for Individuals
                    </Typography>
                    <Typography sx={{ 
                      fontSize: '32px',
                      fontWeight: 700,
                      textAlign: 'center',
                      fontFamily: 'Roboto'
                    }}>
                      Give $50, Get $50
                    </Typography>
                  </Box>
                  {/* 卡片内容 */}
                  <Box sx={{ p: 3 }}>
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      borderBottom: '1px solid #E5E7EB',
                      py: 2
                    }}>
                      <Typography sx={{ color: '#64748B', fontSize: '15px', fontWeight: 400, fontFamily: 'Roboto' }}>You Earn</Typography>
                      <Typography sx={{ fontWeight: 900, color: '#0A2540', fontSize: '17px', fontFamily: 'Roboto' }}>$50</Typography>
                    </Box>
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      borderBottom: '1px solid #E5E7EB',
                      py: 2
                    }}>
                      <Typography sx={{ color: '#64748B', fontSize: '15px', fontWeight: 400, fontFamily: 'Roboto' }}>Friend Saves</Typography>
                      <Typography sx={{ fontWeight: 900, color: '#0A2540', fontSize: '17px', fontFamily: 'Roboto' }}>$50 on Tax Filing</Typography>
                    </Box>
                    <Typography sx={{ 
                      fontSize: '15px',
                      color: '#64748B',
                      mt: 2,
                      lineHeight: 1.5,
                      fontFamily: 'Roboto',
                      fontWeight: 400 
                    }}>
                      Refer a friend for Individual Tax Filing — they get $50 off, and you earn $50!
                    </Typography>
                  </Box>
                </Box>

                {/* Business Tax Filing Card */}
                <Box sx={{ 
                  flex: 1,
                  bgcolor: 'white',
                  borderRadius: 1,
                  overflow: 'hidden',
                  boxShadow: '0px 4px 24px 0px #0000000D'
                }}>
                  {/* 卡片头部 */}
                  <Box
                    sx={{
                      background: 'linear-gradient(90deg, rgb(143, 34, 46) 0%, rgb(22, 119, 255) 100%)',
                      p: 3,
                      color: 'white',
                      borderTopLeftRadius: 16,
                      borderTopRightRadius: 16,
                    }}
                  >
                    <Typography sx={{ 
                      fontSize: '12px',
                      fontWeight: 900,
                      mb: 2,
                      textAlign: 'center',
                      fontFamily: 'Roboto'
                    }}>
                      Tax Filing for Businesses
                    </Typography>
                    <Typography sx={{ 
                      fontSize: '32px',
                      fontWeight: 700,
                      textAlign: 'center',
                      fontFamily: 'Roboto'
                    }}>
                      Give $100, Get $100
                    </Typography>
                  </Box>
                  {/* 卡片内容 */}
                  <Box sx={{ p: 3 }}>
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      borderBottom: '1px solid #E5E7EB',
                      py: 2
                    }}>
                      <Typography sx={{ color: '#64748B', fontSize: '15px', fontWeight: 400, fontFamily: 'Roboto' }}>You Earn</Typography>
                      <Typography sx={{ fontWeight: 900, color: '#0A2540', fontSize: '17px', fontFamily: 'Roboto' }}>$100</Typography>
                    </Box>
                    <Box sx={{ 
                      display: 'flex', 
                      justifyContent: 'space-between',
                      borderBottom: '1px solid #E5E7EB',
                      py: 2
                    }}>
                      <Typography sx={{ color: '#64748B', fontSize: '15px', fontWeight: 400, fontFamily: 'Roboto' }}>Business Saves</Typography>
                      <Typography sx={{ fontWeight: 900, color: '#0A2540', fontSize: '17px', fontFamily: 'Roboto' }}>$100 on Tax Filing</Typography>
                    </Box>
                    <Typography sx={{ 
                      fontSize: '15px',
                      color: '#64748B',
                      mt: 2,
                      lineHeight: 1.5,
                      fontFamily: 'Roboto',
                      fontWeight: 400
                    }}>
                      Refer a business for Business Tax Filing — they get $100 off, and you earn $100!
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* 规则列表部分 */}
              <Box sx={{ 
                bgcolor: '#F8FAFC',
                borderRadius: '24px',
                p: 3,
                // border: '1px solid transparent',
                borderImage: 'linear-gradient(0deg, #E2E8F0, #E2E8F0) 1',
                // boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)'
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Box 
                  component="img" 
                  src={require('../assets/images/right-icon.png')}
                  alt="uTaxes"
                  sx={{ 
                    width: 20,
                    height: 20,
                    mr: 2,
                  }} 
                />
                  <Typography sx={{ 
                    color: '#64748B',
                    fontSize: '15px',
                    lineHeight: 1.5,
                    fontWeight: 400,
                    fontFamily: 'Roboto'
                  }}>
                    Referrals must complete paid tax filing through your unique link
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Box 
                  component="img" 
                  src={require('../assets/images/right-icon.png')}
                  alt="uTaxes"
                  sx={{ 
                    width: 20,
                    height: 20,
                    mr: 2,
                  }} 
                />
                  <Typography sx={{ 
                    color: '#64748B',
                    fontSize: '15px',
                    lineHeight: 1.5,
                    fontWeight: 400,
                    fontFamily: 'Roboto'
                  }}>
                    Available for all U.S. federal and state tax returns
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Box 
                    component="img" 
                    src={require('../assets/images/right-icon.png')}
                    alt="uTaxes"
                    sx={{ 
                      width: 20,
                      height: 20,
                      mr: 2,
                    }} 
                  />
                  <Typography sx={{ 
                    color: '#64748B',
                    fontSize: '15px',
                    lineHeight: 1.5,
                    fontWeight: 400,
                    fontFamily: 'Roboto'
                  }}>
                    Rewards are issued after the referred user completes a paid filing
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>

                <Box 
                  component="img" 
                  src={require('../assets/images/eorr-icon.png')}
                  alt="uTaxes"
                  sx={{ 
                    width: 20,
                    height: 20,
                    mr: 2,
                  }} 
                />
                  <Typography sx={{ 
                    color: '#64748B',
                    fontSize: '15px',
                    lineHeight: 1.5,
                    fontWeight: 400,
                    fontFamily: 'Roboto'
                  }}>
                    Not valid for free filings, existing users, or untracked sign-ups
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Referral Table */}
          <Box sx={{ px: { xs: 2, md: 0 }, mb: 3 }}>
            <TableContainer 
              component={Paper} 
              sx={{ 
                mb: 2,
                boxShadow: 'none',
                '& .MuiTable-root': {
                  borderCollapse: 'separate',
                  borderSpacing: '0 8px'
                }
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ 
                      border: 'none',
                      fontSize: '14px',
                      fontWeight: 600,
                      color: '#333333',
                      padding: '8px 16px'
                    }}>
                      Referral Reward for Business
                    </TableCell>
                    <TableCell align="right" sx={{ 
                      border: 'none',
                      fontSize: '14px',
                      fontWeight: 600,
                      color: '#333333',
                      padding: '8px 16px'
                    }}>
                      Commission
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {referralDataBusiness.map((row) => (
                    <TableRow 
                      key={row.range}
                      sx={{
                        backgroundColor: '#F9FAFB',
                        '& td': { border: 'none' }
                      }}
                    >
                      <TableCell sx={{ 
                        fontSize: '14px',
                        color: '#374151',
                        padding: '12px 16px',
                        fontWeight: 400
                      }}>
                        {row.range}
                      </TableCell>
                      <TableCell 
                        align="right" 
                        sx={{ 
                          fontSize: '14px',
                          fontWeight: 900,
                          color: '#059669',
                          padding: '12px 16px'
                        }}
                      >
                        {row.commission}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          {/* Referral Table */}
          <Box sx={{ px: { xs: 2, md: 0 }, mb: 3 }}>
            <TableContainer 
              component={Paper} 
              sx={{ 
                mb: 2,
                boxShadow: 'none',
                '& .MuiTable-root': {
                  borderCollapse: 'separate',
                  borderSpacing: '0 8px'
                }
              }}
            >
              <Table>
                <TableHead>
                  <TableRow sx={{
                    backgroundColor: '#F3F4F6'
                  }}>
                    <TableCell sx={{ 
                      border: 'none',
                      fontSize: '14px',
                      fontWeight: 600,
                      color: '#333333',
                      padding: '8px 16px'
                    }}>
                      Referral Reward for Individual
                    </TableCell>
                    <TableCell align="right" sx={{ 
                      border: 'none',
                      fontSize: '14px',
                      fontWeight: 600,
                      color: '#333333',
                      padding: '8px 16px'
                    }}>
                      Commission
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {referralData.map((row) => (
                    <TableRow 
                      key={row.range}
                      sx={{
                        backgroundColor: '#F9FAFB',
                        '& td': { border: 'none' }
                      }}
                    >
                      <TableCell sx={{ 
                        fontSize: '14px',
                        color: '#374151',
                        padding: '12px 16px',
                        fontWeight: 400
                      }}>
                        {row.range}
                      </TableCell>
                      <TableCell 
                        align="right" 
                        sx={{ 
                          fontSize: '14px',
                          fontWeight: 900,
                          color: '#059669',
                          padding: '12px 16px'
                        }}
                      >
                        {row.commission}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Description Text */}
            <Typography sx={{ 
              fontSize: '12px',
              color: '#000000',
              lineHeight: '20px',
              fontWeight: 400,
              px: 2
            }}>
              Provide valid contact information of the referred client. After the referral is valid, incentives will be granted based on the scale of the referred client.
            </Typography>
          </Box>
          {/* How it works */}
          <Box sx={{ px: { xs: 2, md: 0 }, mb: 4 }}>
            <Typography sx={{ 
              fontSize: '18px',
              fontWeight: 700,
              color: '#1F2329',
              mb: 2,
            }}>
              How it works
            </Typography>

            {steps.map((step, index) => (
              <Box 
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2,
                  mb: 2,
                  p: 2,
                  backgroundColor: '#F9FAFB',
                  borderRadius: 2
                }}
              >
                {/* Number Circle */}
                <Box sx={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  backgroundColor: '#2563EB',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  mt: 0.5
                }}>
                  <Typography sx={{
                    fontSize: '14px',
                    fontWeight: 600,
                    color: 'white',
                    lineHeight: 1
                  }}>
                    {index + 1}
                  </Typography>
                </Box>

                {/* Content */}
                <Box>
                  <Typography sx={{
                    fontSize: '16px',
                    fontWeight: 900,
                    color: '#111827',
                    mb: 0.5
                  }}>
                    {step.title}
                  </Typography>
                  <Typography sx={{
                    fontSize: '14px',
                    color: '#6B7280',
                    lineHeight: '20px',
                    fontWeight: 400
                  }}>
                    {step.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Rules */}
          <Box sx={{ px: { xs: 2, md: 0 }, mb: 4 }}>
            <Typography sx={{ 
              fontSize: '18px',
              fontWeight: 700,
              color: '#1F2329',
              mb: 2,
            }}>
              Rules
            </Typography>

            {rules.map((rule, index) => (
              <Box 
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2,
                  mb: 2,
                  p: 2,
                  backgroundColor: '#F8F9FA',
                  borderRadius: 2
                }}
              >
                {/* Icon Circle */}
                <Box sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  backgroundColor: '#F9FAFB',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Box sx={{ 
                    color: '#0052CC',
                    '& svg': {
                      fontSize: 24
                    }
                  }}>
                    {rule.icon}
                  </Box>
                </Box>

                {/* Content */}
                <Box>
                  <Typography sx={{
                    fontSize: '16px',
                    fontWeight: 900,
                    color: '#111827',
                    mb: 0.5
                  }}>
                    {rule.title}
                  </Typography>
                  <Typography sx={{
                    fontSize: '14px',
                    color: '#6B7280',
                    lineHeight: '20px',
                    fontWeight: 400
                  }}>
                    {rule.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* Our Service */}
          <Box sx={{ px: { xs: 2, md: 0 }, mb: 4 }}>
            <Typography sx={{ 
              fontSize: '18px',
              fontWeight: 700,
              color: '#1F2329',
              mb: 2,
            }}>
              Our Service
            </Typography>

            {services.map((service, index) => (
              <Box 
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2,
                  mb: 2,
                  p: 2,
                  backgroundColor: '#F9FAFB',
                  borderRadius: 2
                }}
              >
                {/* Icon Circle */}
                <Box sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  backgroundColor: '#E6F7FF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Box sx={{ 
                    color: '#0052CC',
                    '& svg': {
                      fontSize: 24
                    }
                  }}>
                    {service.icon}
                  </Box>
                </Box>

                {/* Content */}
                <Box>
                  <Typography sx={{
                    fontSize: '16px',
                    fontWeight: 900,
                    color: '#111827',
                    mb: 0.5
                  }}>
                    {service.title}
                  </Typography>
                  <Typography sx={{
                    fontSize: '14px',
                    color: '#6B7280',
                    lineHeight: '20px',
                    fontWeight: 400
                  }}>
                    {service.description}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          {/* FAQ */}
          <Box sx={{ px: { xs: 2, md: 0 }, mb: 4 }}>
            <Typography sx={{ 
              fontSize: '18px',
              fontWeight: 600,
              color: '#333333',
              mb: 2,
            }}>
              FAQ
            </Typography>

            {questions.map((question, index) => (
              <Accordion 
                key={index}
                sx={{
                  '&:before': { display: 'none' },
                  boxShadow: 'none',
                  backgroundColor: '#F8F9FA',
                  mb: 1,
                  '&.Mui-expanded': {
                    mb: 1
                  }
                }}
              >
                <AccordionSummary
                  expandIcon={<KeyboardArrowDownIcon sx={{ color: '#666666' }} />}
                  sx={{
                    minHeight: 48,
                    '& .MuiAccordionSummary-content': {
                      margin: '12px 0'
                    }
                  }}
                >
                  <Typography sx={{
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#000000'
                  }}>
                    {question.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{
                    fontSize: '14px',
                    color: '#666666',
                    lineHeight: '20px'
                  }}>
                    {question.content}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Container>


        <Typography sx={{
          fontFamily: {
            xs: 'Roboto', // 移动端样式
            md: 'Roboto'  // PC端样式
          },
          fontWeight: 400,
          fontSize: {
            xs: '10px',  // 移动端字体大小
            md: '14px'   // PC端字体大小
          },
          lineHeight: '17px',
          letterSpacing: '0%',
          textAlign: 'center',
          verticalAlign: 'middle',
          mt: 2,
          mb: 2
        }}>
          uTaxes reserves the right to decide the eligible users for this promotion.
        </Typography> 
        {/* Footer - 仅在非App环境显示 */}
        {!isInApp() && (
          <>
            {/* 预留底部空间 */}
            <Box sx={{ height: { xs: "80px", md: "100px" } }} />
            
            {/* 固定定位的footer */}
            <Box
              sx={{
                borderTop: "1px solid #EAECF0",
                backgroundColor: "#080808",
                height: { xs: "60px", md: "80px" },
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
              }}
            >
              <Container
                sx={{
                  height: "100%",
                  maxWidth: { xs: "1200px", md: "1200px" },
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: { xs: 3, md: 6 },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="img"
                    src={require("../assets/images/logo-bottom.png")}
                    alt="uTaxes"
                    sx={{
                      width: 50,
                      height: 50,
                      marginRight: 1,
                    }}
                  />
                  <Box sx={{ color: "white" }}>
                    <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
                      uTaxes
                    </Typography>
                    <Typography sx={{ fontSize: "12px" }}>
                      Love, Peace of Mind
                    </Typography>
                  </Box>
                </Box>
                <Button
                  variant="contained"
                  onClick={handleDownload}
                  sx={{
                    backgroundColor: "#18c641",
                    color: "white", 
                    borderRadius: 5,
                    fontSize: "13px",
                    fontWeight: 500,
                    padding: "10px 20px",
                    "&:hover": {
                      backgroundColor: "#45a049",
                    },
                  }}
                >
                  JOIN
                </Button>
              </Container>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default ReferralProgram;
